import { CareTeamRole } from '@summer-health/types/care-team';
import { ProactiveCareType } from '@summer-health/types/task';
import { CarePlanItemTriggerType } from './care-plan-item.type';

export interface CarePlanTask {
  carePlanTaskId: string;
  proactiveCareReason: string;
  proactiveCareType: ProactiveCareType;
  promptId: string;
  careTeamRole?: CareTeamRole;
  specifiedProviderId?: string;
  dueDateDelay: number;
}

export interface CarePlanNudge {
  carePlanNudgeId: string;
  message: string;
  promptId: string;
  eventName: string;
  isBotNudge: boolean;
  featureFlag?: string;
}

export enum CarePlanTriggerValueUnits {
  MONTHS = 'month',
  DAYS = 'day',
  HOURS = 'hour',
  MINUTES = 'minute',
  SECONDS = 'second',
}

export interface CarePlanTrigger {
  title: string;
  carePlanTriggerId: string;
  triggerType: CarePlanItemTriggerType;
  locationValue?: string;
  triggerValue: number;
  triggerValueUnits: CarePlanTriggerValueUnits;
  triggerValueOffset: number;
  triggerValueOffsetUnits: CarePlanTriggerValueUnits;
  isTesting: boolean;
  nudges?: CarePlanNudge[];
  tasks?: CarePlanTask[];
}

export const INSURANCE_UPLOAD_TRIGGERS = [
  '2CT9H0Pbfc6cB8W8IBZqyt',
  '6FcC7scpZDEO4p0tOJj6sr',
  '70ynun1HPZ00HJW1eQmwrW',
  '1FpNFEAwaDrRjcVJrOS77s',
];

export const SPONSORED_CAREGIVER_TRIGGERS = ['1oJF9bMiuohLfNCoO7LjQ4'];
